import { useInterviewSessionContext } from '@/context/InterviewSessionContext'
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {useInterviewStore} from "@/store/interviewStore.ts";

export function AvatarScreen() {
  const { language, handleSelectAvatar, handleBackToLanguage } = useInterviewSessionContext()
  const store = useInterviewStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (!store.status) {
      navigate('/', { replace: true })
    }
  }, [store.config, navigate])

  const title = language === 'de' ? 'Wähle deinen Interviewer' : 'Choose your interviewer'
  const backLabel = language === 'de' ? '← Zurück' : '← Back'

  return (
    <div className="tembo-demo-overlay">
      <div className="tembo-demo-content">
        {handleBackToLanguage && (
          <button className="back-btn" onClick={handleBackToLanguage}>
            {backLabel}
          </button>
        )}
        <img src="/images/logo.png" alt="TEMBO Logo" className="tembo-logo" />
        <div className="avatar-selection-title">{title}</div>
        <div className="avatar-selection-buttons">
          <button className="avatar-btn" onClick={() => handleSelectAvatar?.('female')}>
            <img src="/images/avatar-female.jpg" alt="Female interviewer" className="avatar-img" />
          </button>
          <button className="avatar-btn" onClick={() => handleSelectAvatar?.('male')}>
            <img src="/images/avatar-male.jpg" alt="Male interviewer" className="avatar-img" />
          </button>
        </div>
      </div>
    </div>
  )
}
